// extracted by mini-css-extract-plugin
export default {"page":"errorPage_page__nkTjx","code":"errorPage_code__UGxst","title":"errorPage_title__AH9SR","message":"errorPage_message__qCBXH","messageEn":"errorPage_messageEn__pXlxo"};